import { useQuery } from '@tanstack/react-query'

import { loadPastSurveyInformation } from '../../sagas/network'
import { PastSurveys, SurveyInformationData } from 'types/SurveyInformation'
import { Queries } from '../../api/queries.enum'
import { getCompanyUUID } from '../../utils/getCompanyUUID/getCompanyUUID'

type RawSurveyInformationData = Omit<SurveyInformationData, 'pastSurveys'> & {
    pastSurveys: (PastSurveys & { numberOfResponses: number; participationRate: number })[]
}

export const useSurveyInformation = () => {
    const companyUUID = getCompanyUUID()

    return useQuery<RawSurveyInformationData, Error>({
        queryKey: [Queries.getSurveyInformation],
        queryFn: loadPastSurveyInformation,
        enabled: !!companyUUID,
    })
}
